import { render, staticRenderFns } from "./LoanPurpose.vue?vue&type=template&id=0055cbda&scoped=true&"
import script from "./LoanPurpose.vue?vue&type=script&lang=js&"
export * from "./LoanPurpose.vue?vue&type=script&lang=js&"
import style0 from "./LoanPurpose.vue?vue&type=style&index=0&id=0055cbda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0055cbda",
  null
  
)

export default component.exports